import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CatalogueAnalysisTreeComponent } from '@mzic/mzic-components';

@Component({
  selector: 'mzic-catalogue-analysis-demo',
  imports: [CommonModule, CatalogueAnalysisTreeComponent],
  templateUrl: './catalogue-analysis.component.html',
  styleUrls: ['./catalogue-analysis.component.scss'],
})
export class CatalogueAnalysisComponent {}

